import { CheckCircle, Info, WarningCircle } from "@phosphor-icons/react/dist/ssr";
import { cn } from "@/core/shared/v2/lib/utils";

interface InfoBannerProps {
  message: string;
  variant?: "info" | "error" | "success";
  className?: string;
}

export const InfoBanner = ({ message, variant = "info", className }: InfoBannerProps) => {
  const styles = {
    info: "border-blue-200 bg-blue-50 text-blue-800",
    error: "border-red-200 bg-red-50 text-red-800",
    success: "border-green-200 bg-green-50 text-green-800",
  };

  const icons = {
    info: <Info size={24} weight="fill" className="shrink-0 text-blue-600" />,
    error: <WarningCircle size={24} weight="fill" className="shrink-0 text-red-600" />,
    success: <CheckCircle size={24} weight="fill" className="shrink-0 text-green-600" />,
  };

  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-xl border p-4 text-sm leading-relaxed",
        styles[variant],
        className,
      )}
    >
      {icons[variant]}
      <p>{message}</p>
    </div>
  );
};
